export default __webpack_public_path__ + "static/banner-5-tips-for-surviving-the-boxing-day-sales-21d25c9950e888dcda0118e5f5091c45.jpg";